export default __webpack_public_path__ + "static/media/SEC1470.34I-32572_-17872_0.a6552ff8.jpg";